module.exports = __webpack_public_path__ + "img/b站操作图示.c262080b.png";